let SIGN_REGEXP = /([yMdhsm])(\1*)/g;
let DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
  var len = len - (s + '').length;
  for (var i = 0; i < len; i++) {
    s = '0' + s;
  }
  return s;
}

export default {
  powerOptions: [{
    name: "基础数据",
    options: [{
      id: "/company",
      name: "公司信息"
    }, {
      id: "/user",
      name: "操作人员"
    }, {
      id: "/logs",
      name: "登录日志"
    }, {
      id: "/qutype",
      name: "资质类型"
    }]
  },
    {
      name: "签约管理",
      options: [{
        id: "/agents",
        name: "客户档案"
      }, {
        id: "/sign",
        name: "签约登记"
      }]
    }],
  formatDate: function (date, pattern) {
    pattern = pattern || DEFAULT_PATTERN;
    return pattern.replace(SIGN_REGEXP, function ($0) {
      switch ($0.charAt(0)) {
        case 'y':
          return padding(date.getFullYear(), $0.length);
        case 'M':
          return padding(date.getMonth() + 1, $0.length);
        case 'd':
          return padding(date.getDate(), $0.length);
        case 'w':
          return date.getDay() + 1;
        case 'h':
          return padding(date.getHours(), $0.length);
        case 'm':
          return padding(date.getMinutes(), $0.length);
        case 's':
          return padding(date.getSeconds(), $0.length);
      }
    });
  },
  DateAdd(interval, number, date) {
    switch (interval) {
      case "y": {
        date.setFullYear(date.getFullYear() + number);
        return date;
      }
      case "q": {
        date.setMonth(date.getMonth() + number * 3);
        return date;
      }
      case "M": {
        date.setMonth(date.getMonth() + number);
        return date;
      }
      case "w": {
        date.setDate(date.getDate() + number * 7);
        return date;
      }
      case "d": {
        date.setDate(date.getDate() + number);
        return date;
      }
      case "h": {
        date.setHours(date.getHours() + number);
        return date;
      }
      case "m": {
        date.setMinutes(date.getMinutes() + number);
        return date;
      }
      case "s ": {
        date.setSeconds(date.getSeconds() + number);
        return date;
      }
      default: {
        date.setDate(d.getDate() + number);
        return date;
      }
    }
  },
  GetElHeight (tel, bel) {
    tel = tel.getBoundingClientRect();
    let tpoint = {
      left: tel.left + window.scrollX,
      top: tel.top + window.scrollY
    };
    bel = bel.getBoundingClientRect();
    let bpoint = {
      left: bel.left + window.scrollX,
      top: bel.top + window.scrollY
    };
    return (bpoint.top - tpoint.top);
  }
};



// WEBPACK FOOTER //
// ./src/api/Utils.js